import './filter-button.scss';

/**
 * version    1.0
 * class      <type> (FilterButton)
 * classdesc   FilterButton
 */
export class FilterButton {}
